import { ApiResponse, AddRawMaterialResponse } from "../Models";

export const AddRawMaterialsMockup: ApiResponse<AddRawMaterialResponse> = {
  statusCode: 200,
  error: null,
  data: {
    id: 29,
    name: "11-10-12",
  },
};
